import Vue from 'vue';

import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import Meta from 'vue-meta';

import Home from './views/Home.vue';

Vue.use(Router);
Vue.use(RouterPrefetch);
Vue.use(Meta);

/* 23:50 MSK = 20:50 UTC */
const chapterTwoDate = Date.UTC(2019, 3, 9, 20, 50);
const chapterThreeDate = Date.UTC(2019, 3, 11, 15, 0);

const currentDate = new Date();
const currentUTC = Date.UTC(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate(),
    currentDate.getUTCHours(),
    currentDate.getUTCMinutes(),
    currentDate.getUTCSeconds()
);

export default new Router({
    base: process.env.BASE_URL,

    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },

    routes: [
        {
            path: '/',
            alias: '*',
            name: 'Home',
            component: Home
        },
        {
            path: '/chapterone',
            name: 'ChapterOne',
            component: () => import(/* webpackChunkName: "chapter" */ './views/Chapter.vue'),
            props: {
                chapter: 1
            }
        },
        {
            path: '/chaptertwo',
            name: 'ChapterTwo',
            component: () => {
                if (currentUTC < chapterTwoDate) {
                    return Home;
                } else {
                    return import(/* webpackChunkName: "chapter" */ './views/Chapter.vue');
                }
            },
            props: {
                chapter: 2
            }
        },
        {
            path: '/chapterthree',
            name: 'ChapterThree',
            component: () => {
                if (currentUTC < chapterThreeDate) {
                    return Home;
                } else {
                    return import(/* webpackChunkName: "chapter" */ './views/Chapter.vue');
                }
            },
            props: {
                chapter: 3
            }
        }
    ]
});
